<template>
	<div class="buy">
		<div>
			<span class="buy_sp1">确认收货地址</span> <span class="buy_sp2"><a>管理收货地址</a></span>
		</div>
		<hr>
		<br>
		<div class="buy_d2" >
			<div v-if="addressList.length !==0 ">
				<div :class="['buyd2_elc1', index==radio ? 'xuanz' : '']" v-for="(item, index) in addressList" :key="index" @click="handleDivClick(item)" >
					<label :class="['dz', index!=radio ? 'hiden':'']"><img class="dzimg" src="../Home/img/地址.png"/>寄送至</label>
					<el-radio  @click.stop class="address" v-model="radio" :label="index" >
  						{{ `${item.PathName[0]} ${item.PathName[1]} ${item.PathName[2]}` }} {{ item.Adress }} ({{ item.Name }} 收) {{ item.Mobile }}  {{index === 0 ? '默认地址':'' }}
					</el-radio>
					<span :class="['updata', index!=radio ? 'hiden':'']"> <a @click="del(item.id)">删除</a></span> 
					<span :class="['updata', index!=radio ? 'hiden':'']"> <a @click="showFormDialog(item)">修改</a></span>
					
				</div>
			</div>
			
			<button class="btn" @click="toAddress()">使用新地址</button>
			<el-dialog :visible.sync="dialogVisible" title="修改地址" class="updataAddres" :width="device !== 'mobile'?'50%':'100%'">
				<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
					<el-form-item label="收货人" prop="name">
						<el-input class="userirp_d1_inp_address" v-model="ruleForm.name" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="手机号" prop="phone">
						<el-input class="userirp_d1_inp_address" v-model="ruleForm.phone" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="所在地区" prop="checkPass">
						<el-select class="userirp_d1_select_city" v-model="ruleForm.selectedProvince" placeholder="请选择省" @change="getCityData">
							<el-option v-for="(item, index) in provinces" :value="item" :key="index">{{ item }}</el-option>
						</el-select>
						<el-select class="userirp_d1_select_city" v-model="ruleForm.selectedCity" placeholder="请选择市" @change="getDistrictData">
							<el-option v-for="(item, index) in cities" :value="item.Name" :key="index">{{ item.Name }}</el-option>
						</el-select>
						<el-select class="userirp_d1_select_city" v-model="ruleForm.selectedDistrict" placeholder="请选择区" @change="getAreaId()">
							<el-option v-for="item in districts" :value="item.Name" :label="item.Name" :key="item.id">{{ item.Name }}</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="详细地址" prop="address">
						<el-input class="userirp_d1_inp_address" v-model="ruleForm.address" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="设为默认">
						<el-switch v-model="ruleForm.delivery"></el-switch>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
						<el-button @click="resetForm('ruleForm')">重置</el-button>
					</el-form-item>
				</el-form>
			</el-dialog>
		</div>
		<span class="buy_sp1">确认订单信息</span>
		<table class="car_t2">
			<tr>
				<th>商品信息</th>
				<th>规格</th>
				<th>单价</th>
				<th>数量</th>
				<th>小计(元)</th>
			</tr>
			<tr class="good" v-for="(item, index) in orderlist" :key="index">
				<th>
					<div class="car_t2_goods">
						<img :src="imgUrl+item.ProductImg" />
						<div class="car_t2_goods_d2">
							<span>{{ item.ProductName }}</span>
						</div>
					</div>
				</th>
				<th>{{item.ProductSizeName}} * {{item.Count}}</th>
				<th>￥{{item.Price}}</th>
				<th>
					{{item.Count}}
				</th>
				<th>{{item.Price * item.Count }}</th>
			</tr>
			<tr class="heji" v-if="device !== 'mobile'">
				<th rowspan="2">
						<el-input class="buyd4_d1_tex" type="textarea" :rows="2" placeholder="备注留言（限50字以内）" maxlength="50" >
						</el-input>
				</th>
				<th colspan="4">
					配送方式：<el-select class="userirp_d1_select_city" v-model="kd" @change="ChangeKD" >
							<el-option v-for="(item, index) in kdType" :value="item.title" :key="index">{{ item.title }}</el-option>
						</el-select>
				</th>
			</tr>
			<tr class="heji" v-else>
				<th colspan="5">
						<el-input class="buyd4_d1_tex" type="textarea" :rows="2" placeholder="备注留言（限50字以内）" maxlength="50" >
						</el-input>
				</th>
				<!-- <th colspan="4">
					配送方式：<el-select class="userirp_d1_select_city" v-model="kd" @change="ChangeKD" >
							<el-option v-for="(item, index) in kdType" :value="item.title" :key="index">{{ item.title }}</el-option>
						</el-select>
				</th> -->
			</tr>
			<tr class="heji" v-if="device !== 'mobile'" >
				<th colspan="4">
					运费：<span >{{updateOrder}}</span>
				</th>
			</tr>
			<tr class="heji" v-else>
				<th class="kd">
					配送方式：<el-select class="userirp_d1_select_city" v-model="kd" @change="ChangeKD" >
							<el-option v-for="(item, index) in kdType" :value="item.title" :key="index">{{ item.title }}</el-option>
						</el-select>
				</th>
				<th colspan="4">
					运费：<span >{{updateOrder}}</span>
				</th>
			</tr>
			<tr class="heji">
				<th colspan="5">合计：<span>￥{{ total }}</span></th>
			</tr>
		</table>

		<div class="car_t3">
			<div class="cart3_d3">实付款：<span>￥</span><span class="pic">{{ total  }}</span></div>
			<div class="cart3_e4" v-if="addressList.length !==0 ">
				<div>寄送至：{{ `${address.PathName[0]} ${address.PathName[1]} ${address.PathName[2]}` }} {{ address.Adress }}</div>
				<div>收货人：{{ address.Name }} {{ address.Mobile }}</div>
			</div>
		</div>
		<div class="car_t4">
			<el-button class="cart3_e4" type="danger" @click="toPay">前往支付</el-button>
		</div>
		
	</div>
</template>

<script>
import { VUE_APP_IMG_URL } from "@/config";
import { mapGetters } from "vuex"
	export default {
		data() {
			var validateName = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('收货人不能为空'));
				}
				callback();
			};
			var validatePhone = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('手机号不能为空'));
				} else if (!(/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(value))) {
					callback(new Error('手机号校验不通过'));
				} else {
					callback();
				}
			};
			var validateAddress = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('详细地址不能为空'));
				} else {
					callback();
				}
			};
			return {
				addressList:'',
				address:'',
				radio: 0,
				dialogVisible: false,
				num: 1,
				orderlist:[],
				kdType:[],
				kd:'',
				kdid:'',
				updateOrder:0,
				total:0,
				imgUrl: "",
				provinces: [],
    			cities: [],
    			districts: [],
				AreaId:'',
				id:'',
				mr1:true,
				mr2:true,
				ruleForm: {
					name: '',
					phone: '',
					address: '',
					selectedProvince: '',
					selectedCity: '',
					selectedDistrict: '',
					delivery: false
				},
				rules: {
					name: [{
						validator: validateName,
						trigger: 'blur'
					}],
					phone: [{
						validator: validatePhone,
						trigger: 'blur'
					}],
					address: [{
						validator: validateAddress,
						trigger: 'blur'
					}],
					selectedProvince: [{
						required: true,
						message: '请选择省',
						trigger: 'change'
					}],
					selectedCity: [{
						required: true,
						message: '请选择市',
						trigger: 'change'
					}],
					selectedDistrict: [{
						required: true,
						message: '请选择区',
						trigger: 'change'
					}],
				},
			}
		},
		computed: {
			...mapGetters(["device"]),
			
		},
		watch: {

		},
		created: function() {
			this.imgUrl = VUE_APP_IMG_URL;
			this.MyShippingAdressList();
			if (typeof this.$route.query.OrderNo != "undefined") {
      			this.OrderNo = this.$route.query.OrderNo;
      			this.getOrder_Detail();
    		}
			
		},
		beforeDestroy() {
  			const container = document.querySelector('.scroll');
  			container.removeEventListener('scroll', this.handleScroll);
		},
		mounted: function() {
			
			this.getOrder_Detail();
			this.getProvinces();
			this.GetExpressList();
		},
		methods: {
			async getProvinces() {
    	        let res = await this.$post("DefaultProvList", {});
    	        // console.log(res,'DefaultProvList');
    	        this.provinces = res.data.ResultData.ProvinceList;
    	    },
    	    async getCityData() {
    	        let res = await this.$post("GetCityTownList", {province:this.ruleForm.selectedProvince});
    	        console.log(this.ruleForm.selectedProvince,'GetCityTownList');
    	        this.cities = res.data.ResultData.CityList;
				if (this.mr1) {
    				this.mr1 = false;
  				} else {
					this.ruleForm.selectedCity = '';
    	        	this.districts = [];
    	    		this.ruleForm.selectedDistrict = '';
				}
			},
    	    async getDistrictData() {
    	        let res = await this.$post("GetTownList", {city:this.ruleForm.selectedCity});
    	        console.log(res,'GetTownList');
    	        this.districts = res.data.ResultData;
				if(this.mr2){
					this.mr2 = false;
				}else{
					this.ruleForm.selectedDistrict = '';
				}
    	        
          	},
			getAreaId(){
				const selectedDistrictName = this.ruleForm.selectedDistrict;
      			const selectedOption = this.districts.find(item => item.Name === selectedDistrictName);
      			if (selectedOption) {
        			this.AreaId = selectedOption.id;
      			}
				console.log(this.AreaId,'getAreaId');
			},
			async MyShippingAdressList() {
    			var res = await this.$post("MyShippingAdressList", {})
    			console.log(res, 'MyShippingAdressList');
				if(res.data.ResultData.length!=0){
					this.addressList = res.data.ResultData;
					this.address=res.data.ResultData[0];
					this.id=res.data.ResultData[0].id;
				}
    			
  			},
			async getOrder_Detail(){
				var res = await this.$post("getOrder_Detail",{OrderNo:this.OrderNo});
				this.orderlist = res.data.ResultData.order_goods; 
				console.log(res,"getOrder_Detail");
			},
			async del(id){
				await this.$confirm("此操作将永久删除该条地址，是否继续?", "提示", {
        			width: "300px",
        			confirmButtonText: "确定",
        			cancelButtonText: "取消",
        			type: "warning",
      			});
				var res = await this.$post("DelShippingAdress",{ShippingId:id})
    			console.log(res,'删除');
				this.MyShippingAdressList();
			},
			showFormDialog(item) {
      			this.dialogVisible = true;
				this.address= item;	
				console.log(this.address);
				this.ruleForm.name =this.address.Name;
				this.ruleForm.phone =this.address.Mobile;
				this.ruleForm.address = this.address.Adress;
				this.ruleForm.selectedProvince=this.address.PathName[0];
				this.ruleForm.selectedCity = this.address.PathName[1];
				this.ruleForm.selectedDistrict = this.address.PathName[2];
				this.ruleForm.delivery =this.address.IsDeafult;
				this.AreaId=this.address.AreaId;
				this.id=this.address.id;
				this.getCityData();
				this.getDistrictData();
    		},
			handleDivClick(item) {
    			this.handleRadioClick(item);
  			},
  			handleRadioClick(item) {
				this.address= item
				this.id=this.address.id;
				console.log('点击进来updata');
				this.UpdateOrder();
  			},
			async submitForm(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						var res = await this.$post("AddShippingAdress", {
                		Name: this.ruleForm.name,
                		Mobile: this.ruleForm.phone,
                		AreaId: this.AreaId,
                		Adress: this.ruleForm.address,
                		ShippingId: this.id,
            		})
            		console.log(res, '新增/修改');
					if(this.ruleForm.delivery){
						var res = await this.$post("SetDeafultShippingAdress", {
							ShippingId: this.id
    					})
					}
					this.dialogVisible =false
					location.reload();
					} else {
						return false;
					}
				});
			},
			toAddress() {
				this.$router.push("/address")
			},
			resetForm(formName) {
				this.ruleForm.selectedProvince = ''
				this.ruleForm.selectedCity = ''
				this.ruleForm.selectedDistrict = ''
				this.$refs[formName].resetFields();
			},
			deleteRow(index, rows) {
				console.log(index)
			},
			async GetExpressList() {
        		var res = await this.$post("GetExpressList")
        		console.log(res, 'kdType');
				if(res.data.ResultData.length>0){
					this.kdType= res.data.ResultData
					this.kd=res.data.ResultData[0].title
					this.kdid=res.data.ResultData[0].id;
					console.log(this.id,'GetExpressList');
					if(this.id){
						console.log(this.id,'GetExpressList');
						this.UpdateOrder()
					}else{
					}
				}
    		},
			async UpdateOrder() {
        		console.log(this.kdid);
        		var res = await this.$post("UpdateOrder",{OrderNo: this.OrderNo,
                                                    ExpressId: this.kdid,
                                                    MyShippingAdressId: this.id})
        		console.log(res, 'updataorder');
        		this.updateOrder=res.data.ResultData.ExpressCost   
				const orderPrice = res.data.ResultData.OrderPrice
				this.calculateTotal(this.updateOrder, orderPrice)
    		},  
			calculateTotal(value1, value2) {
			    this.total =value1 + value2;
			},
			ChangeKD() {
				console.log(111111);
				const kd = this.kd;
      			const selectedOption = this.kdType.find(item => item.title === kd);
      			if (selectedOption) {
        			this.kdid = selectedOption.id;
      			}
				console.log(this.kdid,'kdid');
        		this.UpdateOrder()
    		},
			toPay(){
				if(this.id){
					this.$router.push({
						path: '/pay',
						query: {
							OrderNo: this.OrderNo,
							OrderPic:this.total
						}
					})
				}else{
				  this.$message.error("请确认收货信息是否填写完整");
				}
				
			}
		}
	}
</script>
<style >
@media (max-width: 992px) {
  .msgbox{
    width: 320px !important;
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.car_t2 {
  width: 100%;
  letter-spacing: 0;
  border-collapse: collapse;
  margin-top: 30px;
}
.good {
  background-color: #fbfcff;
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
  display: table-row;
  font-size: 14px;
}
.heji{
	background-color: #f2f6ff;
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
  height: 50px;	
  text-align: right;
  font-size: 14px;
}
.heji span{
	color: red;
	font-size: 16px;
}
.kd{
	text-align: left;
}
.car_t2_goods {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 30px 26px;
}

.car_t2_goods img {
  width: 100px;
  height: 100px;
  margin-right: 20px;
}

.car_t2_goods_d2 {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: #333333;
  text-align: left;
}
.updataAddres{
	width: 100%;
}

.buy{
	width: 1000px;
	margin: 30px auto;
}

.buy_sp1{
	font-size: 18px;
	color: #333333;
}
.buy_sp2{
	float: right;
	color: #5683fe;
	font-size: 18px;
}

.buy_d2{
	width: 100%;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	margin-bottom: 100px;
}
.dz{
	width: 25px;
	height: 25px;
	color:#fe580d ;
}
.dzimg{
	width: 20px;
	height:20px;
}
.buyd2_elc1{
	/* margin: 0px 0px 15px 18px; */
	padding: 10px;
}
.address{
	margin-left: 30px;
}
.hiden{
	visibility: hidden;
}
.xuanz{
	border:1px solid #fe580d;
	background-color:#fff0e9 ;
}
.updata{
	float: right;
	color: #5683fe;
	font-size: 14px;
	margin-left: 20px;
}
.btn{
	width: 100px;
	height: 30px;
	margin-top: 20px;
	margin-left: 120px;
	border: 1px solid;
    border-radius: 15px;
}
 .userirp_d1_select_city{
	 width: 150px;
	 margin-right: 10px;
 }
 
 .userirp_d1_inp_address{
	 width: 470px;
 }
 .car_t3{
	border: 2px solid red;
	width: 50%;
	text-align: right;
	margin-left: auto;
	height: 100px;
	padding: 20px;
	margin-top: 20px;
 }
 .car_t4{
	width: 50%;
	text-align: right;
	margin-left: auto;
	margin-top: 5px;
 }
 .cart3_d3 span{
	font-size: 28px;
 }
 .pic{
	color: #fe580d;
 }
</style>
<style lang="scss" scoped src="./mobile.scss" ></style>